import { IRankingExtendedSearch } from "src/api/server/extended-search.types";

export const isRankingAvailable = (
    ranking: IRankingExtendedSearch,
    relevanceRanking: IRankingExtendedSearch,
    availableFigureIds: ReadonlySet<string>
): boolean => ranking.id !== null && ranking.id !== relevanceRanking.id && availableFigureIds.has(ranking.id);
